import dayjs from 'dayjs';
import { FormatTimeType } from '../types/format-time.type';

export const getFormattedTime = function (time: string | undefined | null, format: FormatTimeType): string {
  if (!time) {
    return '-';
  }
  return dayjs(time, 'HH:mm:ss').format(format);
};
